import * as React from 'react';
import LogoNavBar from '../../Assets/images/logo-navbar.svg';
import './NavBar.scss';
import Profile from '../Profile';
import { IProfile, IPassword } from '../../Models/Security';
import { IAccount } from '../../Models/Account';

export interface INavbarProps {
	account: IAccount;
	profile?: IProfile;
	onChangePass: (data: IPassword) => void;
}

const NavBar = (props: INavbarProps) => (<div className="navbar">
	<img alt="Logo" className="navbar-logo" src={LogoNavBar} />
	<Profile
		className="navbar-profile"
		email={props.account.username}
		name={props.account.name}
		onChange={props.onChangePass}
		profile={props.profile ? props.profile.description : ''}
	/>
</div>);

export default NavBar;
